import React, { useState, useEffect , useRef} from 'react';
import { Paper, Grid, Avatar, Chip, Typography, InputAdornment, CircularProgress, MenuItem, TextField, IconButton, Card, CardContent, Pagination } from '@mui/material';
import SearchIcon from "@mui/icons-material/Search";
import ApiService from '../../functions/apiService';
import { Link, useParams } from "react-router-dom";
import EmptyState from '../../components/Error/EmptyState';
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
// import './checklist.css'
import moment from 'moment-timezone';
import { useReactToPrint } from "react-to-print";

const StationChecklistSchedule = () => {
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [loading2 , setLoading2] = useState(false);
    const [schedules, setSchedules] = useState(null);
    const [searchResult, setSearchResult] = useState('');
    const [status, setStatus] = useState('')
    const [listType, setListType] = useState('Upcoming')
    const [pastCount, setPastCount] = useState(0)
    const [upcomingCount, setUpcomingCount] = useState(0)
    const printRef = useRef();
    const [checklistScheduleAllData , setChecklistScheduleAllData] = useState([]);
    const [locationDrop, setLocationDrop] = useState([]);

    const handlePrint = useReactToPrint({
        contentRef: printRef,
        onBeforePrint: () =>
        new Promise((resolve) => {
            document.fonts.ready.then(() => resolve());
        }),
    });
    
    let printFunction = () => {
        handlePrint()
    }

    const handleChecklistData = async (id) => {
        if (!id) return;
        setLoading2(true);

        try {
            await Promise.all([
                getChecklistData(id)
            ]);

            setTimeout(()=>{
                printFunction()
                setLoading2(false)
            } , 2000)
        } catch (error) {
            console.error(error);
        } finally {
            setLoading2(false);
        }
    };

    const getSchedule = (loader = true) => {
        const body = {
            "checklist_id": id
        }
        if (searchResult == '' && loader) {
            setLoading(true)
        }
        ApiService.get(`/checklist/station-inspection/schedules?search=${searchResult}&status=${status == 'All' ? '' : status}&type=${listType}`, body)
            .then(({ data }) => {
                setSchedules(data?.data)
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
            })
    }

    const getScheduleCount = (loader = true) => {
        const body = {
            "checklist_id": id
        }
        ApiService.get('/checklist/count', body)
            .then(({ data }) => {
                setUpcomingCount(data?.upcoming_count)
                setPastCount(data?.past_count)

                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
            })
    }

    useEffect(() => {
        getSchedule()
        getScheduleCount()
    }, [searchResult, status, listType])

    useEffect(() => {
        getLocation()
    }, [])

    const getLocation = () => {
        ApiService.get('/checklist/location')
            .then(({ data }) => {
                const posArr = data?.data?.map((pos) => ({ label: pos.location_description, value: pos.id })) || [];
                setLocationDrop(posArr);
            })
            .catch(() => {});
    }

    const getLocationName = (id) => {
        if (!id) return "";
        const match = locationDrop.find(l => l.value == id);
        return match ? match.label : "";
    }

    var time = moment.tz(schedules?.schedules[0]?.checklist_date, 'America/New_York')

    const getChecklistData = (id) => {
        if (id) {
            ApiService.get('/checklist/print-schedule/' + id)
                .then(async ({ data }) => {
                    setChecklistScheduleAllData(data?.data || [])
                    setLoading(false)
                })
                .catch((e) => {
                    console.error(e || 'error')
                })
        }
    }

    return (
        <>
            {loading ? (
                <Paper className="w-100 h-100 d-flex justify-content-center align-items-center font-fam">
                    <CircularProgress />
                </Paper>
            )
                :
                (
                    <>
                        <Paper className="p-4" style={{ marginTop: "1rem" }}>
                            <Grid container className='align-items-center' gap={2} fontFamily={'karla'}>

                                {/* Heading */}
                                {schedules?.title != undefined ?
                                    <Grid item xs={10} md={5}>
                                        <Typography variant="h5">
                                            <Link to="/firehouse/station-checklist" style={{ color: "black" }}>
                                                <ArrowBackIosIcon />
                                            </Link>
                                            {`Checklist > ${(schedules?.title)}`}</Typography>
                                    </Grid>
                                    : ""}

                                {/* Past Chip Button */}
                                <div className={listType == 'Past' ? 'tab-active' : 'tab-white'}
                                    onClick={() => setListType('Past')}>
                                    {`Past (${pastCount})`}
                                </div>

                                {/* Upcoming Chip Button */}
                                <div className={listType == 'Upcoming' ? 'tab-active' : 'tab-white'}
                                    onClick={() => setListType('Upcoming')}>
                                    {`Upcoming (${upcomingCount})`}
                                </div>

                                {/* DropDown Menu Status */}
                                <Grid items xs={12} sm={12} md={2}>
                                    <TextField
                                        select size='small'
                                        placeholder='Status'
                                        className='mt-0 w-100' color='secondary' variant="outlined"
                                        label={"Status"}
                                        value={status}
                                        onChange={(e) => setStatus(e.target.value)}
                                        InputProps={{
                                            sx: {
                                                height: '48px',
                                                fontSize: '14px'
                                            }
                                        }}
                                        InputLabelProps={{
                                            sx: {
                                                marginTop: '4px',
                                                fontSize: '14px'
                                            },
                                        }}
                                    >
                                        <MenuItem value={"All"} key={"All"}>{"All"} </MenuItem>
                                        <MenuItem value={"started"} key={"started"}>{"Started"} </MenuItem>
                                        <MenuItem value={"pending"} key={"pending"}>{"Pending"} </MenuItem>
                                        <MenuItem value={"completed"} key={"completed"}>{"Completed"} </MenuItem>
                                        <MenuItem value={"failed"} key={"failed"}>{"Failed"} </MenuItem>
                                    </TextField>
                                </Grid>

                                {/* Search field */}
                                <Grid item xs={12} sm={12} md={2}>
                                    <TextField
                                        variant="outlined"
                                        placeholder="Search"
                                        onChange={(e) => setSearchResult(e.target.value)}
                                        className="w-100"
                                        value={searchResult}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton>
                                                        <SearchIcon />
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                            sx: {
                                                height: '48px',
                                                fontSize: '14px',
                                                marginRight: '10px',
                                            },
                                        }}
                                    />
                                </Grid>

                                {!schedules || schedules?.schedules?.length == 0 ?
                                    <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 580, width: "100%" }}>
                                        <img src='/images/blur-logo.png' style={{ height: 180 }} />
                                        <span className='mt-4' style={{ color: '#555555' }}>
                                            No Schedules Found
                                        </span>
                                    </div>
                                    :
                                    <Grid container>
                                        {schedules !== null && schedules.schedules.map((item) => (
                                            <Grid item container md={6}>
                                                <Grid item md={12} className="mx-3 mt-3">
                                                    <Card sx={{ backgroundColor: 'rgba(245, 245, 245, 0.4)', marginBottom: '25px', border: '1px solid #cccccc', borderRadius: '12px' }} elevation={0}>
                                                        <CardContent>
                                                            <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #cccccc' }}>
                                                                <p style={{ fontSize: '16px', fontWeight: '550', fontFamily: 'karla' }}>{item?.due_statement}</p> {/* item.schedules?.due_statement  item?.schedules[0]?.due_statement*/}
                                                                <div className="d-flex" style={{ gap: 5 }}>

                                                                    <Link to={`/firehouse/station-checklist-details/${id}/${item?.id}`}>
                                                                        <Chip
                                                                            variant="outlined"
                                                                            sx={{
                                                                                color: '#2B3F6C',
                                                                                border: '1px solid #2B3F6C',
                                                                                cursor: 'pointer'
                                                                            }}
                                                                            avatar={<Avatar src="/images/eye.png" style={{ width: 28, height: 24, padding: 2 }} />}
                                                                            label={"View Details"}
                                                                        />
                                                                    </Link>

                                                                    {item.status == "failed" ?
                                                                        <>
                                                                            <Chip
                                                                                variant="outlined"
                                                                                sx={{
                                                                                    backgroundColor: '#DDDDDD00',
                                                                                    color: '#BF1D2D',
                                                                                    border: '1px solid #BF1D2D',
                                                                                }}
                                                                                avatar={<Avatar src="/images/red-cross.png" style={{ width: 30, height: 30, padding: 5 }} />}
                                                                                label={`Failed (${item?.failed_count})`}
                                                                            />
                                                                            <Link to="/firehouse/tickets">
                                                                                <Chip
                                                                                    variant="outlined"
                                                                                    sx={{
                                                                                        backgroundColor: '#000000',
                                                                                        color: '#FFFFFF',
                                                                                        border: '1px solid #000000',
                                                                                        cursor: 'pointer'
                                                                                    }}
                                                                                    label={`${(item?.ticket_count)} Ticket Raised`}
                                                                                />
                                                                            </Link>
                                                                        </>
                                                                        :
                                                                        item.status == "completed" ?
                                                                            <>
                                                                                <Chip
                                                                                    variant="outlined"
                                                                                    sx={{
                                                                                        backgroundColor: '#DDDDDD00',
                                                                                        color: '#2B3F6C',
                                                                                        border: '1px solid #2B3F6C80',
                                                                                    }}
                                                                                    avatar={<Avatar src="/images/check1.png" style={{ width: 30, height: 30, padding: 7 }} />}
                                                                                    label={`Passed (${item?.passed_count})`}
                                                                                />
                                                                                <Chip
                                                                                    variant="outlined"
                                                                                    sx={{
                                                                                        backgroundColor: '#01784F',
                                                                                        color: '#F5F5F5',
                                                                                        border: '1px solid #01784F',
                                                                                    }}
                                                                                    label={'Completed'}
                                                                                />
                                                                            </>
                                                                            :
                                                                            (item.status == "pending" &&
                                                                                listType == "Past" &&
                                                                                moment(item.checklist_date).isSame(moment(), 'day')) ?
                                                                                <Chip
                                                                                    variant="outlined"
                                                                                    sx={{
                                                                                        backgroundColor: '#FF0000',
                                                                                        color: '#FFFFFF',
                                                                                        border: '1px solid #FF0000',
                                                                                    }}
                                                                                    label={`Overdue by ${Math.floor(moment.duration(moment().diff(moment())).asHours())} Hours ${moment.duration(moment().diff(moment())).minutes()} Minutes`}
                                                                                />
                                                                                :
                                                                                (item.status == "pending" &&
                                                                                    listType == "Past" &&
                                                                                    // moment.tz(item.checklist_date, 'America/New_York').isBefore(moment.tz('America/New_York').subtract(1, 'days'), 'day')) ?
                                                                                    moment(item.checklist_date).isBefore(moment().subtract(1, 'days'), 'day')) ?
                                                                                    <Chip
                                                                                        variant="outlined"
                                                                                        sx={{
                                                                                            backgroundColor: '#FF0000',
                                                                                            color: '#FFFFFF',
                                                                                            border: '1px solid #FF0000',
                                                                                        }}
                                                                                        // label={`Overdue by ${moment.tz('America/New_York').startOf('day').diff(moment.tz(item.checklist_date, 'America/New_York').startOf('day'), 'days')} day(s)`}
                                                                                        label={`Overdue by ${moment().startOf('day').diff(moment(item.checklist_date).startOf('day'), 'days')} day(s)`}
                                                                                    />
                                                                                    :
                                                                                    (item.status == "pending" &&
                                                                                        item.is_filled == 1 &&
                                                                                        listType == "Upcoming" &&
                                                                                        // !moment.tz(item.checklist_date, 'America/New_York').isBefore(moment.tz('America/New_York'), 'day')
                                                                                        !moment(item.checklist_date).isBefore(moment(), 'day')
                                                                                    ) ?
                                                                                        <Chip
                                                                                            variant="outlined"
                                                                                            sx={{
                                                                                                backgroundColor: '#DDDDDD00',
                                                                                                color: '#2B3F6C',
                                                                                                border: '1px solid #2B3F6C',
                                                                                            }}
                                                                                            avatar={<Avatar src="/images/time.png" style={{ width: 30, height: 30, padding: 5 }} />}
                                                                                            label={'Pending'}
                                                                                        />
                                                                                        :
                                                                                        item.status == "pending" &&
                                                                                            listType == "Upcoming" &&
                                                                                            item.is_filled == 0 ?
                                                                                            <Chip
                                                                                                variant="outlined"
                                                                                                sx={{
                                                                                                    backgroundColor: '#DDDDDD00',
                                                                                                    color: '#2B3F6C',
                                                                                                    border: '1px solid #2B3F6C',
                                                                                                }}
                                                                                                avatar={<Avatar src="/images/upcoming.png" style={{ width: 30, height: 30, padding: 5 }} />}
                                                                                                label={'Upcoming'}
                                                                                            />
                                                                                            :
                                                                                            item.status == "started" ?
                                                                                                <Chip
                                                                                                    variant="outlined"
                                                                                                    sx={{
                                                                                                        backgroundColor: '#DDDDDD00',
                                                                                                        color: '#2B3F6C',
                                                                                                        border: '1px solid #2B3F6C',
                                                                                                    }}
                                                                                                    avatar={<Avatar src="/images/fill.png" style={{ height: '12px', width: '20px', padding: 1 }} />}
                                                                                                    label={'Fill started'}
                                                                                                />
                                                                                                :
                                                                                                <Chip
                                                                                                    variant="outlined"
                                                                                                    sx={{
                                                                                                        backgroundColor: '#DDDDDD00',
                                                                                                        color: '#2B3F6C',
                                                                                                        border: '1px solid #2B3F6C',
                                                                                                    }}
                                                                                                    avatar={<Avatar src="/images/time.png" style={{ width: 30, height: 30, padding: 5 }} />}
                                                                                                    label={item.status}
                                                                                                />}

                                                                    <div>
                                                                        <img src='/images/print.svg' width='20px' height='20px' className='mt-1'
                                                                            style={{cursor:'pointer'}}
                                                                            onClick={() => {
                                                                                handleChecklistData(item?.id)
                                                                            }}
                                                                        />
                                                                    </div>

                                                                    
                                                                </div>
                                                            </div>

                                                            <div className='mt-3'>
                                                                <span className="highlight-btn">Assigned to</span>: {item?.employee_full_name}
                                                            </div>

                                                            <div className='mt-3 d-flex'>
                                                                <span className="highlight-btn">Checklist</span>:
                                                                <div className='item-btn'>{schedules?.checklist_station_items_count}</div>
                                                            </div>

                                                        </CardContent>
                                                    </Card>
                                                </Grid>
                                            </Grid>
                                        ))}
                                    </Grid>
                                }
                            </Grid>
                        </Paper >

                        <div ref={printRef} className='print-schedule'>
                            <div>
                                <div className='d-flex align-items-center justify-content-between print-header'>
                                    Firehouse247
                                    <div className='text-center'>
                                        <h4>Checklist Data Report</h4>
                                    </div>
                                    <img src='/images/black-logo.png' style={{ width: 60, height: 60 }} />
                                </div>

                                <div className='mt-2'>
                                    <h5>Checklist Definition</h5>
                                    <div className='font-fam p-3 mt-2 page-break-never' 
                                    style={{display:'flex' , flexDirection:'column' , gap:'6px' , border:'1px solid #cccccc' , borderRadius:'12px' }}>
                                        <div>
                                            <p style={{marginBottom:'0px'}}>Title : <strong>{checklistScheduleAllData?.checklist?.title}</strong></p>
                                        </div>
                                        <div>
                                            <p style={{marginBottom:'0px' , paddingTop:'6px'}}>Status : <strong>{checklistScheduleAllData?.status}</strong></p>
                                        </div>
                                        <div>
                                            <p style={{marginBottom:'0px', paddingTop:'6px'}}>Duration : <strong>{checklistScheduleAllData?.checklist?.duration}</strong></p>
                                        </div>
                                        <div>
                                            <p style={{marginBottom:'0px' , paddingTop:'6px'}}>Day : <strong>{checklistScheduleAllData?.checklist?.day}</strong></p>
                                        </div>
                                        <div>
                                            <p style={{marginBottom:'0px' , paddingTop:'6px'}}>Time : <strong>{checklistScheduleAllData?.checklist?.time}</strong></p>
                                        </div>
                                        <div>
                                            <p style={{marginBottom:'0px' , paddingTop:'6px'}}>Assigned to : <strong>{checklistScheduleAllData?.employee_full_name}</strong></p>
                                        </div>
                                        <div>
                                            <p style={{ marginBottom: "0px" , paddingTop:'6px'}}>
                                                Notify to :
                                                <strong>
                                                    {checklistScheduleAllData?.checklist?.notify
                                                        ?.map(
                                                            (name) =>
                                                                ` ${name?.notify_employee_first_name} ${name?.notify_employee_last_name}`
                                                        )
                                                        .join(", ")}
                                                </strong>
                                            </p>
                                        </div>
                                        <div>
                                            <p style={{marginBottom:'0px' , paddingTop:'6px'}}>Notify Checklist Update to : <strong>{checklistScheduleAllData?.checklist?.notify_checklist_update_to_name}</strong></p>
                                        </div>
                                        <div>
                                            <p style={{marginBottom:'0px' , paddingTop:'6px'}}>Passed checklist count : <strong>{checklistScheduleAllData?.passed_count}</strong></p>
                                        </div>
                                        <div>
                                            <p style={{marginBottom:'0px' , paddingTop:'6px'}}>Failed Checklist count : <strong>{checklistScheduleAllData?.failed_count}</strong></p>
                                        </div>
                                    </div>
                                </div>

                                <div className='mt-3'>
                                    {checklistScheduleAllData?.schedule_reports?.length > 0 && <h5>Checklist</h5>}
                                        <div className='font-fam mt-2' style={{display:'flex' , flexDirection:'column' , gap:'6px' }}>
                                            {checklistScheduleAllData?.schedule_reports && checklistScheduleAllData?.schedule_reports.map((item) => (
                                                <div style={{border:'1px solid #cccccc' , borderRadius:'12px', padding:'14px 12px'}} className='page-break-never'>
                                                    <div style={{display:'flex' , gap:'6px' , width:'280px'}} className='shows-data-side'>
                                                        <div>
                                                            {item?.checklist_item?.location?.type == 'location' ?
                                                                <img src='/images/Building.png' style={{ width: 25, height: 30 }} />
                                                                : item?.checklist_item?.location?.type	 == 'location_item' ?
                                                                <img src="/images/location-item.svg" style={{ width: 23, height: 23 }} />
                                                                :
                                                                <img src="/images/location-blue.svg" style={{ width: 25, height: 25 }} />
                                                        }
                                                        </div>
                                                        <div 
                                                            style={{marginTop: item?.checklist_item?.location?.type == 'location' ? '5px' : '3px' , marginLeft: item?.checklist_item?.location?.type == 'location' ? '-4px' : ''}}
                                                        >
                                                            {(() => {
                                                                const desc = item?.checklist_item?.checklist_item_name || '';
                                                                return desc ? desc.replace(/\w\S*/g, w => w.charAt(0).toUpperCase() + w.slice(1)) : '';
                                                            })()}
                                                        </div>
                                                    </div>

                                                    <div className='mt-2'>
                                                        <p style={{marginBottom:'4px'}}>
                                                            Parent Station : <span style={{color: !item?.checklist_item?.location_id ? '#cccccc' : 'inherit'}}>{getLocationName(item?.checklist_item?.location_id) || '—'}</span>
                                                        </p>
                                                        <p style={{ pointerEvents: !item?.checklist_item?.description ? 'none' : 'auto'}}>
                                                            Description : <span style={{color: !item?.checklist_item?.description ? '#cccccc' : 'inherit',}}>{item?.checklist_item?.description || "No description"}</span>
                                                        </p>
                                                    </div>

                                                    <div>
                                                        <div>
                                                            <Chip style={{ padding:'4px 8px' }}
                                                                    label={item?.status} />
                                                        </div>
                                            
                                                        {item?.ticket &&
                                                            <>
                                                                <h5 className='mt-3 mb-2'>Ticket</h5>
                                                                <div style={{border:'1px solid #cccccc' , borderRadius:'12px', padding:'14px 12px' , marginTop:'10px'}}>
                                                                    <div>
                                                                        <p style={{marginBottom:'0px' , paddingTop:'6px'}}>Ticket title : <strong>{item?.ticket?.title}</strong></p>
                                                                    </div>
                                                                    <div>
                                                                        <p style={{marginBottom:'0px' , paddingTop:'6px'}}>Description : <strong>{item?.ticket?.description || 'No description'}</strong></p>
                                                                    </div>
                                                                    <div style={{display:'flex' , gap:'10px'}}>
                                                                        {item?.ticket?.image &&
                                                                            <div>
                                                                                <p style={{marginBottom:'4px' , paddingTop:'6px'}}>Pri. Image</p>
                                                                                <img src={item?.ticket?.image} width={'100px'} height={'100px'} style={{border:'1px solid #EAECF0' , borderRadius:'8px'}}/>
                                                                            </div>
                                                                        }

                                                                        {item?.ticket?.secondary_image &&
                                                                            <div>
                                                                                <p style={{marginBottom:'4px' , paddingTop:'6px'}}>Sec. Image</p>
                                                                                <img src={item?.ticket?.secondary_image} width={'100px'} height={'100px'} style={{border:'1px solid #EAECF0' , borderRadius:'8px'}}/>
                                                                            </div>
                                                                        }
                                                        
                                                                    </div>
                                                                </div>
                                                            </>
                                                        }
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}
        </>
    )
}
export default StationChecklistSchedule;


